<template>
  <li class="content-tile">
    <div
      :class="[
        'content-tile__overview',
        labNotAvailable && 'content-tile__overview--not-hover',
      ]"
      @click="open"
    >
      <ContentImg :hasAccess="hasAccess" :content="content" />
      <ContentInfo
        :content="content"
        :learningAreaName="learningAreaName"
        :learningAreaColor="learningAreaColor"
      />
      <button
        v-if="!hasAccess"
        class="content-tile__overview__access-btn btn btn--secondary"
      >
        <LockIcon />
        Get access
      </button>
    </div>
    <div v-if="isLevelOpen" class="content-tile__expand">
      <ActionLoader
        v-if="showActionLoader"
        v-show="isContentLoading"
        :loaderClass="'content-delegate__media-loader'"
      />
      <MediaDelegate
        v-bind="{
          parentType: parentType,
          content: {
            media: [content],
            ...content,
            ui_content_type: content.content_type,
          },
          contentTitle,
          userCompletionStatus: currentStatus,
          canStartIssue: true,
          hasAccess,
        }"
        @toggle-quiz="toggleQuiz"
        @is-loading="isContentLoading = !isContentLoading"
      />
    </div>
  </li>
</template>

<script>
import { mapState } from 'vuex'
import { labCommons } from '@/helpers/mixins'
import CONSTANTS from '@/constants'
import MediaDelegate from '@/components/media/MediaDelegate.vue'
import ActionLoader from '@/components/shared/ActionLoader.vue'
import { LockIcon } from 'vue-feather-icons'
import ContentImg from './ContentImg.vue'
import ContentInfo from './ContentInfo.vue'

export default {
  name: 'ContentTile',
  components: {
    ContentImg,
    ContentInfo,
    MediaDelegate,
    ActionLoader,
    LockIcon,
  },
  mixins: [labCommons],
  props: {
    content: {
      type: Object,
      required: true,
    },
    hasAccess: {
      type: Boolean,
      required: true,
    },
    unSubscribedLink: {
      type: String,
      required: true,
    },
    learningAreaName: {
      type: String,
      required: true,
    },
    learningAreaColor: {
      type: String,
      required: true,
    },
    levelOpen: {
      type: String,
      default: '/',
    },
    topicIndex: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isContentLoading: false,
    }
  },
  computed: {
    ...mapState({
      learningPath: state => state.learningPaths.currentLearningPath,
    }),
    parentType() {
      return CONSTANTS.PARENT_CONTENT_TYPES_KEYS.LEARNING_PATH
    },
    isLevelOpen() {
      if (this.levelOpen) {
        const [topicIndexOpen, levelIdOpen] = this.levelOpen.split('/')

        return (
          topicIndexOpen === String(this.topicIndex) &&
          levelIdOpen === this.content.uuid
        )
      }

      return false
    },
    contentTitle() {
      const {
        content: { name },
      } = this
      if (this.content.content_type === 'quiz') {
        if (this.hasAccess) {
          const {
            content: {
              metadata: { quiz_title },
            },
          } = this
          return quiz_title || name || 'Quiz'
        }
        return 'Quiz'
      }
      if (this.content.content_type === 'exercise') {
        if (this.hasAccess) {
          return name || 'Exercise'
        }
        return 'Exercise'
      }
      return name
    },
    currentStatus() {
      const {
        content: { user_status },
      } = this
      return user_status
    },
    showActionLoader() {
      let show = true
      switch (this.content.content_type) {
        case 'iframe':
        case 'quiz':
        case 'video':
          show = false
          break
        default:
          show = true
      }
      return show
    },
  },
  methods: {
    open() {
      if (this.labNotAvailable) return
      if (!this.hasAccess) window.location.href = this.unSubscribedLink
      else {
        switch (this.content.content_type) {
          case 'course':
          case 'lab':
            this.$router.push(
              this.$buildContentLink(
                this.content.content_type,
                {
                  id: this.content.uuid,
                  objectID: this.content.uuid,
                  slug: this.content.slug,
                  learning_areas: [{ name: this.learningAreaName }],
                  parent_type: this.parentType,
                  parent_id: this.learningPath?.id,
                },
                this.learningPath
              )
            )
            break
          default:
            if (this.isLevelOpen) {
              this.$emit('openLevel', null, null)
            } else {
              this.$emit('openLevel', this.topicIndex, this.content.uuid)
            }
        }
      }
    },
    toggleQuiz() {
      this.isOpen = false
      this.$emit('openLevel', null, null)
    },
  },
}
</script>

<style lang="scss" scoped>
.content-tile {
  display: flex;
  flex-flow: row wrap;
  background: var(--glass-mid-gray);
  border-radius: 10px;
  overflow: hidden;

  &__overview {
    display: flex;
    align-items: center;
    flex: 1;
    cursor: pointer;

    &--not-hover {
      cursor: default;
    }

    &__access-btn {
      margin-right: 20px;
      font-family: var(--font-medium);
      svg {
        fill: transparent !important;
      }
    }
  }
  &__expand {
    width: 100%;
    padding: 10px;
  }
}
</style>
